  // Blog Page Toggle

/*$(document).ready(function () {
    $('.select-btn').on('click', function(){
        var accordion = $(this);
        var accordionContent = accordion.next('.options');
        accordion.toggleClass("open");
        accordionContent.slideToggle(250);
    });
	


	$('ul.myList').each( function(index, list) {
		var size_li = $(list).children("li").length;
		var x=10;
		var button = $(list).parent().children('.loadMore');

		hideLoadMore(button, size_li, x)
		$(list).children('li:lt('+x+')').show();
		$(button).click(function (event, ) {
			x= (x+5 <= size_li) ? x+5 : size_li;
			hideLoadMore(button, size_li, x)

			$(list).children('li:lt('+x+')').show();
		});
	});
});*/

//Product Filters
document.addEventListener("DOMContentLoaded", function(event) {
    let filters = document.querySelectorAll('.select-menu');
    if(filters) {
        filters.forEach(
            function(el, key, parent) {
                new Filter(el)
            }
        )
    }
});

class Filter {
    accordion;
    content;
    options;
    button;
    slide = 250;
    show = 10;
    height = 0;
    hidden = false;
    constructor(wrapper) {
        this.accordion = wrapper.querySelector('.select-btn');
        this.content = wrapper.querySelector('.options');
        this.button = wrapper.querySelector('.loadMore');
        this.options = wrapper.querySelectorAll('.filter-nav li.option');
        this.list = wrapper.querySelector('.myList')
        
        this.resized();

        this.accordion.addEventListener('click', () => this.handleAccordion());
        this.button.addEventListener('click', () => this.loadMore());
        this.list.querySelectorAll('li:nth-child(-n+'+this.show+')').forEach( el => el.style.display = 'block' );
        this.hideLoadMore();

        window.addEventListener("resize", () => this.resized());

        
    }
    
    handleAccordion() {
        this.hidden = !this.hidden;
        this.toggleOptions();
    }
    
    toggleOptions() {
        if(this.hidden)
            this.accordion.classList.remove('open');
        else
            this.accordion.classList.add('open');
        this.content.style.display = this.hidden ? "none" : "block";
    }
    
    loadMore() {
        let size_li = this.options.length;
        this.show = (this.show+5 <= size_li) ? this.show+5 : size_li;
        this.hideLoadMore()
        this.list.querySelectorAll('li:nth-child(-n+'+this.show+')').forEach( el => el.style.display = 'block' );
    }

    hideLoadMore() {
		if(this.show >= this.options.length) {
			this.button.style.display = 'none';
		}
	}

    resized() {
        if(window.screen.width < 690) {
            this.hidden = true;
        } else {
            this.hidden = false;
        }
        this.toggleOptions();
    }
}

//Patterns page url Category Selector
const blogFilter = document.querySelector('#BlogTagFilter');
if(blogFilter) {
    blogFilter.addEventListener('change', function () {
        var url = this.value; // get selected value
        if (url) { // require a URL
            window.location = url; // redirect
        }
        return false;
    });
}

// Slider for Top products and for Often used Products.
class Slider {
    elements;
    buttons;
    position = 0;
    movePosition;
    maxPosition;
    responsive;

    constructor(wrapper, config) {
        this.elements = {
            container: wrapper.querySelector('.slider-container'),
            items: wrapper.querySelectorAll('.slider-item'),
        };
        this.buttons = {
            prev: wrapper.querySelector('.btn-prev'),
            next: wrapper.querySelector('.btn-next'),
        };
        this.responsive = config.responsive;
        this.position = this.elements.container.scrollLeft;

        const itemWidth = this.elements.items[0].clientWidth + parseInt(getComputedStyle(this.elements.items[0]).marginRight.replace('px', ''));
        this.movePosition = itemWidth * config.slidesToScroll

        this.maxPosition = this.elements.container.scrollWidth - (this.elements.container.clientWidth);
        this.buttons.prev.addEventListener('click', () => this.handlePrevClick());
        this.buttons.next.addEventListener('click', () => this.handleNextClick());
        this.elements.container.addEventListener('scroll', () => this.handleScroll());
        const resizeObserver = new ResizeObserver( entries => {
            for (let entry of entries ) {
                this.handleResize(entry);
            }
        });
        resizeObserver.observe(this.elements.container)
        this.checkBtns();
    }

    handleScroll() {
        this.position = Math.ceil(this.elements.container.scrollLeft)
        this.checkBtns();
        //console.log(this.position)
    }

    handleResize(entry) {
        let config;
        if(Array.isArray(this.responsive)) {
        for(let breakpoint of this.resposnsive) {
            console.log(breakpoint >= entry.contentRect.width)
            if(breakpoint.breakpoint >= entry.contentRect.width) {
                config = breakpoint.settings;
            }
        }
        const itemWidth = this.elements.items[1].clientWidth + parseInt(getComputedStyle(this.elements.container).columnGap.replace('px', ''));
        console.log(itemWidth)
        this.movePosition = config.slidesToScroll * itemWidth;
        this.maxPosition = -(this.elements.items.length * itemWidth - config.slidesToShow * itemWidth);
        }
    }

    handlePrevClick() {
        this.position -= this.movePosition;
        if(this.position <= 0) {
            this.position = 0;
        }   
        this.setPosition();
    }

    handleNextClick() {
        this.position += this.movePosition;
        if(this.position >= this.maxPosition) {
            this.position = this.maxPosition;
        }
        this.setPosition();
    }

    animate({timing, draw, duration}) {
        let start = performance.now();

        requestAnimationFrame(function animate(time) {
            // timeFraction goes from 0 to 1
            let timeFraction = (time - start) / duration;
            if (timeFraction > 1) timeFraction = 1;

            // calculate the current animation state
            let progress = timing(timeFraction)

            draw(progress); // draw it

            if (timeFraction < 1) {
            requestAnimationFrame(animate);
            }

        });

    }

    setPosition() {
        const container = this.elements.container;
        const position = this.position;
        const start = container.scrollLeft;
        const move = this.movePosition;
        if('scrollBehavior' in document.documentElement.style) {
            container.scrollLeft = this.position
        } else {
        this.animate({
            duration: 500,
            timing(timeFraction) {
                return timeFraction;
            },
            draw(progress) {
                if(start >= position) {
                    container.scrollLeft = start - (move * progress);
                } else {
                    container.scrollLeft = (move * progress) + start;
                }
                if(progress === 1) {
                }
            }
        })
        }
    }

    checkBtns() {  
        this.buttons.prev.disabled = this.position === 0;
        this.buttons.next.disabled = this.position >= this.maxPosition;
    }
}
